import * as React from 'react';
import { AdsSessionContextProvider } from './session/AdsSessionContextProvider.js';
import { AdsSystemContextProvider } from './system/AdsSystemContextProvider.js';

var DesignSystemContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(AdsSystemContextProvider, {
    value: value
  }, /*#__PURE__*/React.createElement(AdsSessionContextProvider, {
    value: value
  }, children));
});
DesignSystemContextProvider.displayName = 'DesignSystemContextProvider';

export { DesignSystemContextProvider };
//# sourceMappingURL=DesignSystemContextProvider.js.map
